import { render, staticRenderFns } from "./dictionaries.vue?vue&type=template&id=71339a0e&scoped=true&"
import script from "./dictionaries.vue?vue&type=script&lang=js&"
export * from "./dictionaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71339a0e",
  null
  
)

export default component.exports